const TOPICS = [
  { label: '动作片', count: '3,286部', hot: true },
  { label: '科幻片', count: '1,892部', hot: true },
  { label: '喜剧片', count: '4,510部', hot: false },
  { label: '恐怖片', count: '1,203部', hot: false },
  { label: '爱情片', count: '3,670部', hot: false },
  { label: '悬疑片', count: '2,145部', hot: true },
  { label: '动画片', count: '2,890部', hot: false },
  { label: '纪录片', count: '1,540部', hot: false },
  { label: '战争片', count: '876部', hot: false },
  { label: '犯罪片', count: '1,932部', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            发现你感兴趣的电影类型，探索更多精彩内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <a
              key={topic.label}
              href="#cards"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-500/15 text-accent-400 border border-accent-500/30 hover:bg-accent-500/25'
                  : 'bg-background-200/60 text-foreground-300 border border-background-300/30 hover:border-primary-500/30 hover:text-primary-400'
              }`}
            >
              {topic.label}
              <span className={`text-xs ${topic.hot ? 'text-accent-500/60' : 'text-foreground-600'}`}>
                {topic.count}
              </span>
              {topic.hot && (
                <i className="ri-fire-line text-xs text-accent-500"></i>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}